export default {
    title: 'شعبه‌ها',
    searchPlaceholder: 'جستجوی شعبه...',
    columns: {
        name: 'نام',
        location: 'موقعیت',
        abbr: 'اختصاری',
        initialContractId: 'شروع قرارداد',
        center: 'مرکز',
        qbLocation: 'موقعیت کوییک‌بوکس',
        parent: 'شعبه والد',
        depositAccounts: 'حساب‌های واریزی',
        visps: 'VISPهای متصل',
        contractInfo: 'اطلاعات قرارداد',
        receiptInfo: 'قالب رسید پرداخت'
    },
    tabs: {
        general: 'اطلاعات عمومی',
        contract: 'اطلاعات قرارداد',
        receipt: 'رسید پرداخت',
        integration: 'سیستم و حسابداری'
    },
    contractInfo: {
        sectionTitle: 'اطلاعات قرارداد',
        language: 'زبان قرارداد',
        selectLanguage: 'انتخاب زبان',
        phone: 'شماره تماس در قرارداد',
        phonePlaceholder: 'مثلا ۹۳۷۹۹۶۵۶۵۸۰+ یا ۰۷۱۱۶۵۶۵۸۰',
        address: 'آدرس شعبه در قرارداد',
        addressPlaceholder: 'مثلا جاده بانک خون، امام مسلم ۱۱، هرات',
        languages: {
            fa: 'فارسی / دری',
            ps: 'پښتو (پشتو)',
            mazar: 'مزار شریف (دری)'
        }
    },
    receiptInfo: {
        sectionTitle: 'تنظیمات رسید پرداخت',
        template: 'قالب چاپ رسید',
        templateText: 'فقط متن (کاغذ پیش‌چاپ)',
        templateFull: 'طرح کامل با سربرگ و ته برگ (کاغذ سفید)',
        phone: 'شماره خدمات مشتریان در رسید',
        phonePlaceholder: '0787315151 / 0728315151 (پیش‌فرض)',
        phoneHint: 'در صورت خالی بودن، شماره پیش‌فرض خدمات مشتریان (0787315151 / 0728315151) چاپ می‌شود.',
        address: 'آدرس شعبه در رسید',
        addressPlaceholder: 'آدرس اختصاصی رسید (اختیاری)',
        addressHint: 'در صورت خالی بودن، از آدرس قرارداد استفاده می‌شود.',
        preprintedNotice: 'کاغذهای پیش‌چاپ از قبل در چاپخانه با شماره تماس و آدرس رسمی چاپ شده‌اند و نیازی به چاپ مجدد ندارند.'
    },
    account: 'حساب',
    accounts: 'حساب',
    actions: {
        add: 'افزودن',
        edit: 'ویرایش',
        delete: 'حذف شعبه',
        copyId: 'کپی شناسه شعبه',
        update: 'بروزرسانی شعبه'
    },
    dialog: {
        add: {
            title: 'افزودن شعبه جدید',
            description: 'جزئیات شعبه جدید را در اینجا وارد کنید. پس از اتمام روی ذخیره کلیک کنید.'
        },
        update: {
            title: 'بروزرسانی شعبه',
            description: 'جزئیات این شعبه را بروزرسانی کنید. پس از اتمام روی ذخیره کلیک کنید.'
        },
        save: 'ذخیره تغییرات',
        cancel: 'انصراف'
    },
    fields: {
        generalInfo: 'اطلاعات عمومی شعبه',
        integrationSettings: 'تنظیمات اتصال و سرور',
        name: 'نام',
        location: 'موقعیت',
        abbr: 'اختصاری',
        initialContractId: 'شناسه شروع قرارداد',
        initialContractIdPlaceholder: 'مثلا 9154',
        center: 'مرکز',
        selectCenter: 'انتخاب مرکز',
        loadingCenters: 'در حال بارگذاری...',
        radiusServer: 'ردیوس سرور',
        selectRadiusServer: 'انتخاب ردیوس سرور',
        noRadiusServer: 'بدون ردیوس سرور',
        loadingRadiusServers: 'در حال بارگذاری ردیوس سرورها...',
        visps: 'VISPهای متصل',
        selectVisps: 'انتخاب VISP(ها)',
        searchVisps: 'جستجوی VISPها...',
        loadingVisps: 'در حال بارگذاری VISPها...',
        noVisps: 'VISP یافت نشد',
        noMatchingVisps: 'VISP با این مشخصات یافت نشد',
        selectRadiusFirstForVisps: 'ابتدا ردیوس سرور را انتخاب کنید',
        vispsAvailable: 'VISP موجود',
        defaultVisp: 'VISP پیش‌فرض',
        selectDefaultVisp: 'انتخاب VISP پیش‌فرض',
        noDefaultVisp: 'بدون پیش‌فرض (خودکار)',
        selectVispsFirst: 'ابتدا VISPها را انتخاب کنید',
        qbLocation: 'موقعیت کوییک‌بوکس',
        selectQbLocation: 'انتخاب موقعیت کوییک‌بوکس',
        loadingQbLocations: 'در حال بارگذاری...',
        selectLocation: 'انتخاب موقعیت کوییک‌بوکس',
        loadingLocations: 'در حال بارگذاری...',
        parent: 'شعبه والد',
        selectParent: 'انتخاب شعبه والد',
        noParent: 'بدون والد',
        loadingBranches: 'در حال بارگذاری...',
        qboDepositAccounts: 'حساب‌های واریزی کوییک‌بوکس',
        selectDepositAccounts: 'انتخاب حساب‌های واریزی',
        searchDepositAccounts: 'جستجوی حساب‌های واریزی...',
        loadingDepositAccounts: 'در حال بارگذاری حساب‌ها...',
        noDepositAccounts: 'حساب واریزی یافت نشد',
        noMatchingAccounts: 'حسابی با این نام یافت نشد',
        selected: 'انتخاب شده',
        clearSelection: 'پاک کردن',
        selectAll: 'انتخاب همه',
        deselectAll: 'لغو انتخاب همه',
    },
    notifications: {
        idCopied: {
            title: 'شناسه شعبه کپی شد',
            description: 'شناسه شعبه در کلیپ‌بورد کپی شد.'
        },
        deleted: {
            title: 'شعبه حذف شد',
            description: 'شعبه با موفقیت حذف شد.'
        },
        error: {
            title: 'خطا',
            description: 'حذف شعبه با خطا مواجه شد. لطفا مجددا تلاش کنید.'
        }
    }
} 